/*eslint-disable*/
import React from 'react';
import { Link } from 'react-router-dom';

// components

import IndexDropdown from 'components/Dropdowns/IndexDropdown.js';

export default function Navbar(props) {
  const [navbarOpen, setNavbarOpen] = React.useState(false);
  return (
    <>
      <nav className='top-0 fixed w-10/12 z-50 bg-white shadow res-navbar flex flex-wrap items-center justify-between navbar-expand-lg p-4 desktopview '>
        <div className='container px-4 mx-auto flex flex-wrap items-center justify-between'>
          <div className='w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start '>
            <i class='fas fa-search text-color-yellow'></i>
            <span className='text-color-btn mx-4'>Search</span>
          </div>

          <div
            className='flex  items-center bg-white lg:bg-opacity-0 lg:shadow-none '
            id='example-navbar-warning'
          >
            <ul className='flex flex-col lg:flex-row list-none lg:ml-auto'>
              <li className='flex float- items-center'>
                <IndexDropdown />
              </li>
              <li className='flex items-center'>
                <a className=' px-3' href='#'>
                  <i className='fas fa-globe ' />
                </a>
              </li>
              <li className='flex items-center'>
                <a className=' px-2' href='#'>
                  <i className='far fa-comment-alt' />
                </a>
              </li>

              <li className='flex items-center'>
                <a className=' px-3 ' href='#'>
                  <i className='fas fa-ellipsis-v text-color-yellow' />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}
